import { getColorValue } from '../lib/utils';

import type { IconProps } from '.';

export const Box = ({ bgColor = 'illustration-line', fgColor = 'illustration-face', size = 48 }: IconProps) => {
  const bgHsl = getColorValue(bgColor);
  const fgHsl = getColorValue(fgColor);

  return (
    <svg fill="none" viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
      <path fill={fgHsl} d="m34 5.5 23 11-24 42-25.5-13v-26L34 5.5Z" />
      <path
        fill={bgHsl}
        d="M58.3 16.2a1 1 0 0 0-.5-.9A364 364 0 0 0 34.8 5h-.2c-5-.4-27.7 13.8-28.4 15a1 1 0 0 0-.1.8v6c0 6.5-.2 15.3 0 19 0 .4.2.7.5 1l25.5 13a1 1 0 0 0 1 0c16.1-9.9 24.5-15.5 24.9-17 .7-3 .4-24 .3-26.5Zm-24.8 15-11.9-5.4 23.5-14.2L56.3 17 33.5 31ZM8 45a687.5 687.5 0 0 1 0-24.3c1.3-1 6.3-4.2 12-7.4C30.7 7.4 33.7 7 34.4 7c1.2.3 4.6 1.8 8.6 3.6L19.4 24.8l-6.7-3a1 1 0 1 0-.8 1.8l6.4 3V32c0 .6.4 1 1 1 .5 0 1-.4 1-1v-4.7L32.5 33v24.7L8 45.1Z"
      />
    </svg>
  );
};
